/**
 * Development Environment Configuration
 * 
 * Used when building with: ng build --configuration=dev
 * Angular's file replacement mechanism will replace environment.ts
 * with this file during the dev build process.
 */

import { buildPasswordResetUrl } from './environment.common';

/** Firebase Hosting / custom domain for the dev SPA — update if you use a different host. */
const APP_ORIGIN = 'https://ledger.dev.elodt.com';

export const environment = {
  production: false,
  envName: 'DEV',
  appVersion: '0.0.2-dev',
  // Use Firebase Hosting rewrite (/api/**) to keep same-origin requests.
  apiBaseUrl: 'https://ledger.dev.elodt.com/api',
  appUrl: APP_ORIGIN,
  passwordResetUrl: buildPasswordResetUrl(APP_ORIGIN),
  supabaseUrl: 'https://ytoiruseyiyamtlwajph.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl0b2lydXNleWl5YW10bHdhanBoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAzOTE3NjcsImV4cCI6MjA4NTk2Nzc2N30.Agwdg9h2XKeLmHQ3vuyL9AujiHkfveAndMMmpnICkcE',
  allowPublicRegistrationFallback: false,
};

